/**
 * What primary does with traffic a capability receives. primary owns this vocabulary — only some
 * channel/direction pairs accept a webhook type, and primary's model enforces which.
 */
export var PhoneNumberWebhookType;
(function (PhoneNumberWebhookType) {
    PhoneNumberWebhookType["AgentConversationIncoming"] = "AgentConversationIncoming";
})(PhoneNumberWebhookType || (PhoneNumberWebhookType = {}));
//# sourceMappingURL=webhookType.js.map